import { RootState } from '@/domain/store';

export const selectImpactStatsPublic = (state: RootState) => {
  return state.impactStats.public;
};
